import { createModuleStreamFetcher } from './createModuleStreamFetcher';

export default createModuleStreamFetcher({
  url: '/module/badge_activity',
});
